import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ModalRouteService {
  route: string;
  routeSubject: Subject<string> = new Subject();

  changeRoute(route: string) {
    this.routeSubject.next(route);
  }
}
